import React, { Component } from 'react'
import { translate } from 'react-i18next'

import { getDurationView } from './../../libs/utils'

import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import getByPath from 'lodash/get'
import config from '../../config'
import CommentList from './CommentList'


class Event extends Component {
  static propTypes = {
    data: PropTypes.object,
    customizedPlanId: PropTypes.string
  }

  static defaultProps = {
    data: {},
    customizedPlanId: ''
  }

  static navUrl = 'https://maps.google.com?saddr=Current+Location&daddr='

  constructor(props) {
    super(props)

    this.state = {
      isOpen: true,
      imagesLoaded: false,
      loadedItems: []
    }
  }


  navigateTo(e, event) {
    console.log('navigating to...')
    if (event.contentPOIs && event.contentPOIs.length > 0) {
      const poi = event.contentPOIs[0]
      const place = poi.place ? poi.place : poi.location
      if (place) {
        window.open(Event.navUrl + place.lat + ',' + place.lng); 
      }
    }
  }

  renderEventDetails() {
    const photos = getByPath(this.props, 'data.eventPhotos', []);

    return (
      <div style={{ marginTop: 10 }}>
        <div className="event__photos">
        {photos.map((photo, i) => {
          /*const imgStyle = {
            backgroundImage: `url(${config.imgApiUrl}/${photo.secret}/230x230)`
          }*/

          const imgStyle = {
            backgroundImage: `url(${photo.file.s3Url})`
          }

          //const imgsrc = config.imgApiUrl + '/' + photo.secret + '/230x230'
          const imgsrc = photo.file.s3Url;

          return  (
            <div className="event__photo" key={i}>
              <img src={imgsrc} style={{height: "230px", width: "230px"}}></img>
            </div>)
        })}
        </div>

        <div className="plan-part__search-result search-result">
          <div style={{wordBreak: 'normal'}} className="search-result__title" dangerouslySetInnerHTML={{ __html: this.props.data.description }} />
        </div>

        {this.props.data.contentPOIs && this.props.data.contentPOIs.length > 0 &&
        <div
          className="comment-list__switch"
          onClick={e => {
            this.navigateTo(e, this.props.data)
          }}
        >
          <i className="fa fa-road" /> <span>ניווט</span>
        </div>
        }
        <CommentList contentEventId={this.props.data.id} customizedPlanId={this.props.customizedPlanId} user={this.props.user} />
      </div>
    )
  }

  render() {

    const { data } = this.props

    let originalTz = data.tz
    if (!originalTz) {
      originalTz = 'Asia/Jerusalem'
    }
    let startTime = moment(data.startdate).tz(originalTz).format('HH:mm')
    let durationView = getDurationView(data.startdate, data.enddate, this.props.t)
    let timeDuration = startTime + (durationView ?  ', ' + durationView : '')

    return (
      <div className="trip-date__event">
        <span className="event__time">{timeDuration}&nbsp;|&nbsp;</span>
        <span
          className="event__title"
          onClick={() => {
            this.setState(state => ({
              isOpen: !state.isOpen
            }))
          }}
        >
          {this.props.data.title}
        </span>
        {this.state.isOpen && this.renderEventDetails()}
      </div>
    )
  }
}

export default translate('trip_planner')(Event)



// WEBPACK FOOTER //
// src/components/MyTrip/Event.js